import React from "react";
import NotifyConfigWorkspace from "../../components/NotifyConfigWorkspace";

export default function AdminConfigureNotifyPage() {
  return (
    <NotifyConfigWorkspace
      title="Configure Notifications"
      subtitle="Refine in-app notification templates for this workspace."
      eyebrow="Admin"
      icon="notifications"
      allowEmailTab={false}
      statusTabbed
    />
  );
}
